import React from 'react';
import '../App.css';

function ProjectDetail() {
    return (
        <section id="project-detail">
            <h2>Project 1: [Project Title]</h2>
            <p><strong>Description:</strong> Detailed description of the project and its purpose.</p>
            <p><strong>Technologies Used:</strong> Java, Spring Boot, HTML, CSS, JavaScript</p>
            <p><strong>Role:</strong> Your role in the project, such as developer, team lead, etc.</p>
            <p><strong>Features:</strong></p>
            <ul>
                <li>Feature 1: Description of feature 1.</li>
                <li>Feature 2: Description of feature 2.</li>
                <li>Feature 3: Description of feature 3.</li>
            </ul>
            <p><strong>Screenshots:</strong></p>
            <img src="screenshot1.png" alt="Screenshot of Project 1" />
            <img src="screenshot2.png" alt="Screenshot of Project 1" />
            <p><strong>Link to Live Project:</strong> <a href="http://example.com">Visit Project</a></p>
        </section>
    );
}

export default ProjectDetail;
